import { useEffect, useState } from "react";
import api from "../utils/api";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Box,
} from "@mui/material";
import useDarkMode from "./useDarkMode";
import { Helmet } from "react-helmet-async";

const PlatformStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useDarkMode();

  useEffect(() => {
    async function fetchStats() {
      try {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem("token");
        const data = await api.get("admin/stats", token);
        setStats(data);
      } catch (err) {
        setError("Failed to load statistics.");
      } finally {
        setLoading(false);
      }
    }
    fetchStats();
  }, []);

  return (
    <>
      <Helmet>
        <title>AKAAL KIDS - Admin Panel | Platform Stats</title>
      </Helmet>
      <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 4 }}>
        <Card sx={{ maxWidth: 500, width: "100%", boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Platform Statistics
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Overview of platform usage and key metrics.
            </Typography>
            {loading && <Typography>Loading...</Typography>}
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            {stats && (
              <List>
                <ListItem>Total Users: {stats.totalUsers}</ListItem>
                <ListItem>Total Batches: {stats.totalBatches}</ListItem>
                <ListItem>Total Enrollments: {stats.totalEnrollments}</ListItem>
                <ListItem>Total Level: {stats.totalLevels}</ListItem>
                {/* Add more stats as needed */}
              </List>
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default PlatformStats;
